import { configureStore } from "@reduxjs/toolkit";
import orderDetails from "../features/orderDetailsSlice";
import responseReducer from "../features/responseSlice";
import rolesAndPermissionsReducer from "../features/roleAndPermissionsSlice"
import todoReducer from "../features/TodoSlice";
import employeeReducer from "../features/employeeSlice";
import authorizationReducer from "../features/authorizationSlice";
import deliveryOrdersReducer from "../features/DeliveryOrdersCountSlice"
import dropOffReducer from "../features/DropOffSlice";
import overviewSlice from "../features/overviewSlice";
import webSocketSlice from "../features/webSocketSlice";

const store = configureStore({
    reducer: {
        orderDetails: orderDetails,
        transferResponse: responseReducer,
        rolesAndPermissions: rolesAndPermissionsReducer,
        todo: todoReducer,
        employees: employeeReducer,
        authorization: authorizationReducer,
        deliveryOrdersCount: deliveryOrdersReducer,
        dropOff: dropOffReducer,
        overview: overviewSlice,
        websocket: webSocketSlice,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredPaths: ['websocket.webSocketClient'],
                ignoredActionPaths: ['payload', 'meta.arg', 'meta.requestId'],
            },
        }),
});

export default store;